export const classesData = [
  {
    id: "class1",
    name: "GENERAL CLASSES",
    lpButton: "Learn More",
    image: require("../../Assets/GeneralClassB.png"),
    levels: [
      {
        id: "class1_level1",
        name: "BEGINNERS CLASS 1",
        levelImage: require("../../Assets/BC1B.png"),
        time: ["Saturday & Sunday", "8:00am - 9:30am"],
        fee: null,
        venue: "Telegram",
        subjects: ["Qiraa’ah (Reading)", "Hadeeth", "Hifz (Memorization)", "Imlaa (Dictation)", "Adhkar/Adab"],
        classes: null,
        goals: [
          "Students will learn to recognize, pronounce, and write the Arabic alphabet including their various forms depending on their position in words.",
          "Students will start reading simple verses from the Qur'an, with guidance on meaning and context to enhance their spiritual and linguistic understanding.",
          "Students will learn basic etiquettes and prayers as muslimahs.",
        ],
        cButton: "Register Now",
      },
      {
        id: "class1_level2",
        name: "BEGINNERS CLASS 2",
        levelImage: require("../../Assets/BC2B.png"),
        time: ["Saturday & Sunday", "8:00am - 10:00am"],
        fee: "£16.50 | $16.50",
        venue: "Telegram",
        subjects: [
          "Qiraa’ah (Reading)",
          "Hadeeth",
          "Hifz (Memorization)",
          "Imlaa (Dictation)",
          "Adhkar/Adab",
          "Tajweed",
        ],
        classes: null,
        goals: [
          "Students read the Qur’an fluently with the basic tajweed rules.",
          "Students will learn basic arabic words and their meanings.",
          "Students will be able to memorise one juz of the Qur’an.",
          "Students will be able to read.",
        ],
        cButton: "Register Now",
      },
      {
        id: "class1_level3",
        name: "BEGINNERS CLASS 3",
        levelImage: require("../../Assets/BC1B.png"),
        time: ["Saturday & Sunday", "8:00am - 10:30am"],
        fee: null,
        venue: "Telegram",
        subjects: [
          "Arabiyyah",
          "Qiraa’ah (Reading)",
          "Hadeeth",
          "Hifz (Memorization)",
          "Imlaa (Dictation)",
          "Adhkar/Adab",
        ],
        classes: null,
        goals: [
          "Students will be able to recite and memorize a certain portion of the Quran.",
          "Students will be able to converse in simple arabic words and conversation.",
          "Students will practice writing simple sentences in Arabic, starting with basic subject-verb-object constructions.",
        ],
        cButton: "Register Now",
      },
      {
        id: "class1_level4",
        name: "IDAADIY'",
        levelImage: require("../../Assets/IB.png"),
        time: ["Saturday & Sunday", "8:00am - 9:30am"],
        fee: null,
        venue: "Telegram",
        subjects: ["Nahw", "Sarf", "Aqeedah", "Fiqh", "Arabiyyah", "Hadeeth"],
        classes: null,
        goals: [
          "Students will expand their vocabulary to include words related to daily life, Islamic terminology, and classical Arabic used in texts like the Quran and Hadith.",
          "Students will be introduced to the basic principles of Fiqh, understanding the classification of actions (e.g., obligatory, recommended, permissible, etc.) and their applications in daily life.",
          "Students will engage in more complex conversations, practicing both formal and informal Arabic to develop fluency in different settings.",
        ],
        cButton: "Register Now",
      },
    ],
  },
  {
    id: "class2",
    name: "KIDDIES CLASSES",
    lpButton: "Learn More",
    image: require("../../Assets/KiddiesClassB.png"),
    levels: [
      {
        id: "class2_level1",
        name: "KIDDIES CLASS 1",
        levelImage: require("../../Assets/KC1B.png"),
        time: ["Saturday & Sunday", "8:00am - 9:30am"],
        fee: null,
        venue: "Telegram",
        subjects: ["Qiraa’ah (Reading)", "Hadeeth", "Hifz (Memorization)", "Imlaa (Dictation)", "Adhkar/Adab"],
        classes: null,
        goals: [
          "Children will be able to recognize, name, and pronounce all 28 letters of the Arabic alphabet.",
          "Children will learn the basic sounds (phonics) associated with each letter, focusing on clear and correct pronunciation.",
          "Children will sing simple Arabic songs and nursery rhymes to reinforce their vocabulary and pronunciation in a fun way.",
        ],
        cButton: "Register Now",
      },
      {
        id: "class2_level2",
        name: "KIDDIES CLASS 2",
        levelImage: require("../../Assets/KC2B.png"),
        time: ["Saturday & Sunday", "8:00am - 9:30am"],
        fee: null,
        venue: "Telegram",
        subjects: ["Qiraa’ah (Reading)", "Hadeeth", "Hifz (Memorization)", "Imlaa (Dictation)", "Adhkar/Adab"],
        classes: null,
        goals: [
          "Children will fully recognize, pronounce, and with all 28 letters of the Arabic alphabet in both isolated and connected forms..",
          "Children will start to write short, simple sentences on their own, focusing on correct letter formation, spacing, and basic punctuation.",
          "Children will begin memorizing short, simple Quranic verses or phrases, along with their meanings, to connect their Arabic learning with Islamic studies.",
        ],
        cButton: "Register Now",
      },
      {
        id: "class2_level3",
        name: "KIDDIES CLASS 3",
        levelImage: require("../../Assets/KC2B.png"),
        time: ["Saturday & Sunday", "8:00am - 9:30am"],
        fee: null,
        venue: "Telegram",
        subjects: [
          "Qiraa’ah (Reading)",
          "Hadeeth",
          "Hifz (Memorization)",
          "Imlaa (Dictation)",
          "Adhkar/Adab",
          "Arabiyyah",
        ],
        classes: null,
        goals: [
          "Children will practice more detailed conversational phrases, including asking and answering basic questions.",
          "Children will work on memorizing additional surahs from the Quran, with an emphasis on understanding their meanings and how they apply to daily life.",
          "Children will be encouraged to speak Arabic confidently, whether in class discussions, role-playing, or presentations, even if they make mistakes.",
        ],
        cButton: "Register Now",
      },
    ],
  },
  {
    id: "class3",
    name: "PRIVATE CLASS",
    levellessImage: require("../../Assets/PCB.png"),
    lpButton: "Learn More",
    image: require("../../Assets/PrivateClassB.png"),
    time: ["Flexible days", "1 hour max"],
    fee: null,
    venue: "Telegram",
    subjects: null,
    classes: ["Once weekly", "Twice weekly", "Thrice weekly", "Four times weekly"],
    goals: ["Depending on the pace of the student."],
    cButton: "Register Now",
    levels: null,
  },
  {
    id: "class4",
    name: "FAMILY CLASS",
    levellessImage: require("../../Assets/FCB.png"),
    lpButton: "Learn More",
    image: require("../../Assets/FamilyClassB.png"),
    time: ["Twice weekly", "Flexible time"],
    fee: null,
    venue: "Telegram",
    subjects: null,
    classes: ["Group of 3", "Group of 6"],
    goals: ["Depending on the pace of the students."],
    cButton: "Register Now",
    levels: null,
  },
  {
    id: "class5",
    name: "TAHFEEDH CLASS",
    levellessImage: require("../../Assets/TCB.png"),
    lpButton: "Learn More",
    image: require("../../Assets/TahfeezClassB.png"),
    time: ["Saturday & Sunday", "30 mins max"],
    fee: null,
    venue: "Telegram",
    subjects: null,
    classes: ["Juz Amma", "Juz Mulk", "Juz Mujaadilah", "Juz Dhaariyyat", "Juz Ahqoof etc."],
    goals: [
      "Students will memorize the surahs in the Qur’an fluently.",
      "Students will learn the proper tajweed rules.",
      "Students will basic etiquette and prayer as muslimahs.",
    ],
    cButton: "Register Now",
    levels: null,
  },
];
